<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item class="select_btn_160" v-if="activeName == 'video' || activeName == 'book' || activeName == 'period'">
      <el-select
        class="select_btn_style"
        v-model="filters.displayClientTypes"
        placeholder="展示终端"
        multiple
      >
        <el-option
          v-for="(item, i) in typeList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="学习时间：" class="m-l-14" v-if="activeName !== 'period' && activeName !== 'news'">
      <el-date-picker
        class="date-picker"
        value-format="yyyy-MM-dd"
        size="small"
        v-model="filters.studyTime"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.name"
        :placeholder="placName"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
import moment from "moment";
import { dateStringByday } from '@/utils/timeFormat';
export default {
  name: "search",
  components: {
    butn,
  },
  props: ["placName", "activeName"],
  data() {
    return {
      size: "small",
      filters: {
        studyTime: [],
      },
      typeList: [],
    };
  },
  created() {
    this.getSysParamByTypes(["DISPLAY_CLIENT_TYPE"]);
    this.initTime();
  },
  watch: {
    activeName(val) {
      this.initTime();
    }
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        // res.data["DISPLAY_CLIENT_TYPE"].splice(0, 0, {
        //   paramKey: "",
        //   paramValue: "全部",
        // });
        this.typeList = res.data["DISPLAY_CLIENT_TYPE"] || [];
      });
    },
    initTime() {
      if (this.activeName !== 'period' && this.activeName !== 'news') {
        let date = new Date();
        let time = dateStringByday(date, 7);
        this.$set(this.filters, 'studyTime', time);
      }
      // this.initData();
    },
    initData() {
      let params = { ...this.filters };
      if (this.filters.studyTime && this.filters.studyTime.length > 1) {
        params["studyStartTime"] = moment(this.filters.studyTime[0]).format("YYYY-MM-DD");
        params["studyEndTime"] = moment(this.filters.studyTime[1]).format("YYYY-MM-DD");
        delete params.studyTime;
      }
      this.$emit("search", { ...params, t: new Date().getTime() });
    },
    resetName() {
      this.filters = {};
    },
    resetData() {
      this.filters = {};
      if (this.activeName == 'video') {
        this.initTime();
        this.initData();
      } else {
        this.$emit("search", { t: new Date().getTime() });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pro_input {
  width: 120px;
  margin-right: 10px;
}
</style>
